import { Truck } from 'lucide-react';
import { PhaseStubPage } from '@/components/layout/PhaseStubPage';

export function ShipmentsPage() {
  return (
    <PhaseStubPage
      title="Shipments"
      phase={4}
      modules={[
        'Pick list generation (per location, per wave)',
        'Pack station with barcode scan',
        'Carrier label print (FedEx/UPS/USPS via ShipStation)',
        'Tracking webhook ingest → status updates back to channel',
      ]}
      icon={Truck}
    />
  );
}
